<nav>
  <div class="logo">
    <a routerLink="/">
      <img src="assets/static/icons/logo_ivision.svg" alt="Logo" />
    </a>
  </div>
  <div class="nav-links">
    @for (navLink of navbarLinks; track $index) {
      <div
        class="nav-link"
        [ngClass]="{
        active: isCurrentRoute(navLink.route),
        disabled: !canNavigate(navLink.route)
      }"
      >
        <div class="icon icon_nav">
          <img [src]="navLink.iconPath" alt="{{ navLink.label }} icon" />
        </div>
        <a [routerLink]="canNavigate(navLink.route) ? navLink.route : null">
          {{ navLink.label }}
        </a>
      </div>
    }
  </div>
  <div class="user-actions">

    <div
      class="user-action processing-status"
      [ngClass]="{ active: isCurrentRoute('/video-status') }"
    >
      <a [routerLink]="['/video-status']" class="icon" title="Estado de Procesamiento">
        <img src="assets/static/icons/camera-reels.svg" alt="Processing Status icon" />
      </a>
    </div>

    @if (isUserAdmin) {
      <div
        class="user-action admin-panel"
        [ngClass]="{ active: isCurrentRoute('/admin-page') }"
      >
        <a [routerLink]="['/admin']" class="icon" title="Panel de Administración">
          <img src="assets/static/icons/settings.svg" alt="Admin Panel icon" />
        </a>
      </div>
    }

    <div
      class="user-action profile"
      [ngClass]="{ active: isCurrentRoute('/profile') }"
    >
      <a [routerLink]="['/profile']">
        {{ user?.name || user?.loginName || user?.email || "Yo" }}
      </a>
    </div>
    <div class="user-action">
      <a [routerLink]="['/logout']">
        <img src="assets/static/icons/logout.svg" alt="Logout icon" />
      </a>
    </div>
  </div>
</nav>
